import crypto from 'crypto';
export var sha256Hash = function sha256Hash(str) {
  return crypto.createHash('sha256').update(str).digest('hex');
};
export var extractUrlHostname = function extractUrlHostname(sourceUrl) {
  var url;
  try {
    url = new URL(sourceUrl);
  } catch (_unused) {
    return undefined;
  }
  return url.hostname;
};